import { useMutation } from '@tanstack/react-query'
import type { ApplicationCheckRequest, ApplicationCheckResponse } from '@mobi/api-types'
import { get, SignUpUrl } from '../../../Utils'

type UseApplicationCheckOptions = {
  onSuccess?: (data: ApplicationCheckResponse) => void
  onError?: () => void
}

export const useApplicationCheck = (options?: UseApplicationCheckOptions) => {
  return useMutation<ApplicationCheckResponse, Error, ApplicationCheckRequest>({
    mutationFn: getApplicationCheck,
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  })
}

export function getApplicationCheck(params: ApplicationCheckRequest) {
  const queryString = new URLSearchParams({
    lastName: params.lastName,
    birthdate: params.birthdate,
  }).toString()
  return get<ApplicationCheckResponse>(`${SignUpUrl.applicationCheck}?${queryString}`)
}
